/* unplugin-vue-components disabled */import { render } from "./icon_recipe.vue?vue&type=template&id=ddf5ecd0&scoped=true"
const script = {}

import "./icon_recipe.vue?vue&type=style&index=0&id=ddf5ecd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf5ecd0"]])

export default __exports__